const SPARKS = [[8, 12], [22, 70], [35, 30], [48, 85], [62, 18], [74, 55], [88, 32], [93, 78], [15, 45], [55, 60]];

export default function Backdrop() {
  return (
    <div aria-hidden className="fixed inset-0 z-0 overflow-hidden pointer-events-none">
      <div className="blob w-[520px] h-[520px] -top-40 -left-32" style={{ background: "var(--pink-soft)" }} />
      <div className="blob w-[420px] h-[420px] top-1/3 -right-40" style={{ background: "var(--gold)", opacity: 0.25, animationDelay: "-5s" }} />
      <div className="blob w-[460px] h-[460px] bottom-[-180px] left-1/3" style={{ background: "var(--pink)", opacity: 0.18, animationDelay: "-9s" }} />
      {SPARKS.map(([x, y], i) => (
        <span key={i} className="sparkle" style={{ left: `${x}%`, top: `${y}%`, animationDelay: `${i * 0.4}s` }} />
      ))}
    </div>
  );
}
